import { z } from 'zod'

import ZAction from '@/app/module/campaigns/types/schemas/actions/all-actions'

const ZOnInvalidReply = z.object({
  actions: z.array(ZAction).optional(),
})

export default ZOnInvalidReply
